// Image Slider Functionality
export const initializeImageSlider = () => {
  const imageContainers = document.querySelectorAll('.image-slider-container');

  imageContainers.forEach((container) => {
    const images = container.querySelectorAll('img');
    const leftArrow = document.createElement('button');
    const rightArrow = document.createElement('button');
    const dotsContainer = document.createElement('div');

    let currentIndex = 0;
    let autoSlideInterval;

    // Create arrow buttons
    leftArrow.classList.add('slider-arrow', 'slider-arrow-left');
    leftArrow.innerHTML = '&#10094;'; // Left arrow
    rightArrow.classList.add('slider-arrow', 'slider-arrow-right');
    rightArrow.innerHTML = '&#10095;'; // Right arrow

    // Create dots container
    dotsContainer.classList.add('slider-dots');
    images.forEach((image, index) => {
      const dot = document.createElement('span');
      dot.addEventListener('click', () => {
        showImage(index);
        resetAutoSlide();
      });
      dotsContainer.appendChild(dot);
    });

    // Append arrows and dots
    container.appendChild(leftArrow);
    container.appendChild(rightArrow);
    container.appendChild(dotsContainer);

    function showImage(index) {
      images.forEach((img) => img.classList.remove('active'));
      images[index].classList.add('active');

      const dots = dotsContainer.querySelectorAll('span');
      dots.forEach((dot) => dot.classList.remove('active'));
      dots[index].classList.add('active');

      currentIndex = index;
    }

    function nextImage() {
      currentIndex = (currentIndex + 1) % images.length;
      showImage(currentIndex);
    }

    function prevImage() {
      currentIndex = currentIndex === 0 ? images.length - 1 : currentIndex - 1;
      showImage(currentIndex);
    }

    function startAutoSlide() {
      autoSlideInterval = setInterval(nextImage, 4000);
    }

    function resetAutoSlide() {
      clearInterval(autoSlideInterval);
      startAutoSlide();
    }

    // Show the first image initially
    showImage(currentIndex);

    // Handle left arrow click
    leftArrow.addEventListener('click', () => {
      prevImage();
      resetAutoSlide();
    });

    // Handle right arrow click
    rightArrow.addEventListener('click', () => {
      nextImage();
      resetAutoSlide();
    });

    // Start automatic sliding
    startAutoSlide();
  });
};
